import newsdesk from './newsdesk'
import nrcs from './nrcs'
import preferences from './preferences'
import boundaries from './boundaries'
import dashboard from './dashboard'
import docker from './docker'
import uploader from './uploader'
import archiveRundowns from './archiveRundowns'
import roles from './roles'

export default {
  newsdesk,
  nrcs,
  boundaries,
  dashboard,
  docker,
  preferences,
  uploader,
  archiveRundowns,
  roles
}
